import { __decorate, __metadata } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
/**
 * Footer shared by the three Team Operations section modals: change count, Save and Cancel.
 */
let TeamOperationsEditFooter = /** @class */ (() => {
    let TeamOperationsEditFooter = class TeamOperationsEditFooter extends Vue {
        save() { }
        close() { }
    };
    __decorate([
        Prop({ default: "" }),
        __metadata("design:type", String)
    ], TeamOperationsEditFooter.prototype, "countText", void 0);
    __decorate([
        Prop({ default: "Save" }),
        __metadata("design:type", String)
    ], TeamOperationsEditFooter.prototype, "saveLabel", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TeamOperationsEditFooter.prototype, "canSave", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TeamOperationsEditFooter.prototype, "saving", void 0);
    __decorate([
        Emit("save"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TeamOperationsEditFooter.prototype, "save", null);
    __decorate([
        Emit("close"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TeamOperationsEditFooter.prototype, "close", null);
    TeamOperationsEditFooter = __decorate([
        Component({
            name: "TeamOperationsEditFooter",
        })
    ], TeamOperationsEditFooter);
    return TeamOperationsEditFooter;
})();
export default TeamOperationsEditFooter;
